import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DataEndpoint } from '@core/models/general.model';
import { Observable, map } from 'rxjs';
import { GlobalWarmingPotentialModel } from '../models/global-warming-potential.model';

@Injectable({
  providedIn: 'root',
})
export class GlobalWarmingPotentialApi {
  private readonly http = inject(HttpClient);
  private readonly GLOBAL_WARMING = '/GlobalWarmingPotential';

  getGlobalWarmingPotential(): Observable<DataEndpoint<GlobalWarmingPotentialModel[]>> {
    const url = this.GLOBAL_WARMING;

    return this.http.get<DataEndpoint<GlobalWarmingPotentialModel[]>>(url)
      .pipe(map((data: DataEndpoint<GlobalWarmingPotentialModel[]>) => {
        return {...data}
      }));
  }
}
